import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { EditWorkbook } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';
import { toNativePromise } from '../../../commonInfra/utils/QUtils';
import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { openReactConfirmationDialog } from '../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../commonInfra/dialogs/style/TabDialogWidth';
import { ActionHelpers } from '../../../ts/services/ActionHelpers';
import { ExtractTasks } from '../../../extract/resources/ExtractTasks';
import { ExtractDraftAvaliableDialog } from '../../../extract/components/ExtractDraftAvaliableDialog';

export interface EditWorkbookAction extends Action {
  workbook: IContentInfo;
}


export function editWorkbook(workbook: IContentInfo): EditWorkbookAction {
  return {
    type: EditWorkbook,
    workbook
  };
}

export const isEditWorkbookAction = isActionFactory<EditWorkbookAction>(EditWorkbook);
